/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import PhClock from 'ember-phosphor-icons/components/ph-clock';
import PhCheckCircle from 'ember-phosphor-icons/components/ph-check-circle';
import PhXCircle from 'ember-phosphor-icons/components/ph-x-circle';
import { GuestIdentityVerificationStatus } from 'uplisting-frontend/models/occasion';

interface IArgs {
  status: GuestIdentityVerificationStatus;
}

export interface BookingStatusGuestIdentityVerificationSignature {
  Element: HTMLDivElement;

  Args: IArgs;
}

export default class UiBookingStatusGuestIdentityVerificationComponent extends Component<BookingStatusGuestIdentityVerificationSignature> {
  @cached
  get status(): GuestIdentityVerificationStatus {
    return this.args.status;
  }

  @cached
  get alertClass():
    | 'inline-alert-danger'
    | 'inline-alert-processing'
    | 'inline-alert-success' {
    switch (this.status) {
      case GuestIdentityVerificationStatus.requiresInput:
      case GuestIdentityVerificationStatus.requiresAction:
        return 'inline-alert-danger';
      case GuestIdentityVerificationStatus.processing:
      case GuestIdentityVerificationStatus.overridden:
        return 'inline-alert-processing';
      case GuestIdentityVerificationStatus.verified:
      case GuestIdentityVerificationStatus.succeeded:
        return 'inline-alert-success';
    }
  }

  @cached
  get iconComponent():
    | typeof PhXCircle
    | typeof PhCheckCircle
    | typeof PhClock
    | undefined {
    switch (this.status) {
      case GuestIdentityVerificationStatus.requiresInput:
      case GuestIdentityVerificationStatus.requiresAction:
        return PhXCircle;
      case GuestIdentityVerificationStatus.processing:
        return PhClock;
      case GuestIdentityVerificationStatus.verified:
      case GuestIdentityVerificationStatus.succeeded:
      case GuestIdentityVerificationStatus.overridden:
        return PhCheckCircle;
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Booking::Status::GuestIdentityVerification': typeof UiBookingStatusGuestIdentityVerificationComponent;
  }
}
